var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLocal),expression:"showLocal"}],attrs:{"type":_vm.type,"indeterminate":""}},[_vm._v(_vm._s(_vm.message)+"\n\t")])
}
var staticRenderFns = []

export { render, staticRenderFns }